export const capitalizeFirstLetter = (str: string) => {
  return str[0].toUpperCase() + str.slice(1).toLowerCase()
}

export const capitalizeFirstLetterWithDelimiter = (str: string, delimiter: string, separator = ' ') => {
  return str.split(delimiter).map(word => capitalizeFirstLetter(word)).join(separator)
}